<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      1.1 {{ $t('common_words.company_general_info') }}
    </p>
    <hr />
    <br />
    <div class="row">
      <div class="col-md-4 col-xl-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.nit')}: *`"
          v-model="model.nit"
          name="common_words.nit"
          v-validate="modelValidations.nit"
          :error="getError('common_words.nit', true)"
          placeholder="123456789-0"
        ></fg-input>
      </div>
      <div class="col-md-4 col-xl-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: `"
          v-model="model.code"
          :placeholder="`${$t('common_words.company_code')}...`"
        ></fg-input>
      </div>
      <div class="col-md-4 col-xl-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.cost_center')}: `"
          v-model="model.cost_center"
          :placeholder="`0011`"
          name="common_words.cost_center"
          v-validate="modelValidations.cost_center"
          :error="getError('common_words.cost_center', true)"
        ></fg-input>
      </div>
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('common_words.company_name_enter')}...`"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          type="number"
          :label="`${$t('common_words.phone')}: *`"
          placeholder="3334567890"
          v-model="model.phone"
          name="common_words.phone"
          v-validate="modelValidations.phone"
          :error="getError('common_words.phone', true)"
        ></fg-input>
      </div>
      <div class="col-12 col-lg-6">
        <fg-input
          type="email"
          :label="`${$t('common_words.main_email')}: *`"
          placeholder="xxxx@gmail.com"
          v-model="model.email"
          name="common_words.main_email"
          v-validate="modelValidations.email"
          :error="getError('common_words.main_email', true)"
        ></fg-input>
      </div>
      <div class="col-12">
        <fg-input
          type="tradename"
          :label="`${$t('common_words.comercial_name')}: `"
          :placeholder="`${$t('common_words.comercial_name_enter')}...`"
          v-model="model.tradename"
          name="nombre comercial"
        ></fg-input>
      </div>
      <div class="col-12">
        <div class="form-group has-label">
          <div class="form-group has-label">
            <label>{{ $t('common_words.comercial_activity') }}</label>
            <br />
            <el-input
              maxlength="150"
              show-word-limit
              class="shadow-sm"
              type="textarea"
              :rows="2"
              :placeholder="`${$t('common_words.economic_activity_enter')}...`"
              v-model="model.comercial_activity"
            ></el-input>
            <br />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group has-label">
          <div class="form-group has-label">
            <label>{{ $t('common_words.guild2') }}</label>
            <br />
            <el-input
              maxlength="500"
              show-word-limit
              class="shadow-sm"
              type="textarea"
              :rows="2"
              :placeholder="`${$t('common_words.company_info_enter')}...`"
              v-model="model.about_you"
            ></el-input>
            <br />
          </div>
        </div>
      </div>
      <div class="col-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.website')}: `"
          placeholder="https://xxxxxx.com"
          v-model="model.web_site"
        ></fg-input>
      </div>
      <div class="col-3">
        <fg-input
          type="text"
          :label="`${$t('common_words.icon')}: `"
          :placeholder="$t('common_words.icon2')"
          v-model="model.icon"
        ></fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-6 mt-2" v-if="renderComponent">
        <div class="form-group has-label">
          <label class="text-transform-none">
            {{ $t('common_words.type_of_company') }}:
          </label>
          <a
            v-tooltip.top-center="$t('common_words.manage_types_companies')"
            class="btn-info btn-simple btn-link custom-margin-actions custom-icon-size"
            @click.prevent="openModal('business_types')"
          >
            <em class="fa fa-pencil-square-o"></em>
          </a>
          <br />
          <el-select
            @change="selectAllFromSelect('model.type_ids', business_types)"
            multiple
            collapse-tags
            clearable
            class="select-primary custom-width-select cat-box shadow-sm"
            size="large"
            v-model="model.type_ids"
            :placeholder="`${$t('common_words.select')}... `"
            filterable
          >
            <el-option
              v-for="option in business_types"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.type"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-6 mt-2" v-if="renderComponent && isGroupBusiness()">
        <div class="form-group has-label">
          <label class="text-transform-none">
            {{ $t('common_words.company_contain') }}
          </label>
          <br />
          <el-select
            @change="
              selectAllFromSelect('model.businesses_ids', businesses_list)
            "
            multiple
            collapse-tags
            clearable
            class="select-primary custom-width-select cat-box shadow-sm"
            size="large"
            v-model="model.businesses_ids"
            :placeholder="`${$t('common_words.select')}... `"
            filterable
          >
            <el-option
              v-for="option in businesses_list"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <el-dialog
        v-if="isCreate() || isUpdate()"
        width="74%"
        top="2%"
        :close-on-click-modal="false"
        :title="$t('common_words.manage_types_companies2')"
        :visible.sync="modals.business_types"
      >
        <div class="row">
          <div class="col-12">
            <span style="font-size: 15px; word-break: break-word">
              {{ $t('common_words.company_record_info') }}
            </span>
            <hr />
          </div>
        </div>
        <div class="row mt-4">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <div class="col-12 mb-2 ml-0">
              <a @click="addTypesRow" style="cursor: pointer">
                <em class="fa fa-plus" style="color: #2891b0"></em>
                {{ $t('common_words.add_record') }}
              </a>
            </div>
            <el-table style="width: 100%" :data="queriedData" :border="true">
              <el-table-column
                prop="type"
                :label="$t('common_words.type_of_company')"
              >
                <template slot-scope="scope">
                  <el-input
                    maxlength="100"
                    show-word-limit
                    clearable
                    size="small"
                    style="text-align: center"
                    v-model="scope.row.type"
                  >
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="is_group_businesses"
                :label="$t('common_words.companies_question')"
              >
                <template slot-scope="scope">
                  <el-select
                    clearable
                    class="select-default mt-1 shadow-sm dismiss-height"
                    v-model="scope.row.is_group_businesses"
                    :placeholder="`${$t('common_words.select')}... `"
                    filterable
                  >
                    <el-option
                      class="select-default"
                      v-for="(item, index) in [
                        { id: 1, label: 'Si' },
                        { id: 0, label: 'No' },
                      ]"
                      :key="index"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="30"
                :label="$t('common_words.actions')"
              >
                <template slot-scope="scope">
                  <a
                    v-if="isCreate()"
                    v-tooltip.top-center="$t('common_words.save')"
                    class="btn-success btn-simple btn-link"
                    @click="storeUpdateBusinessTypes(scope.$index, scope.row)"
                    ><em class="fa fa-floppy-o"></em>
                  </a>
                  <a
                    v-if="isDelete()"
                    v-tooltip.top-center="$t('common_words.delete')"
                    class="btn-danger btn-simple btn-link"
                    slot="reference"
                    @click="deleteBusinessType(scope.$index, scope.row)"
                  >
                    <em class="fa fa-times"></em>
                  </a>
                </template>
              </el-table-column>
            </el-table>
            <hr />
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-2"
          >
            <div class="">
              <p class="card-category" style="font-size: 14px">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              ref="paginationTypes"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            >
            </l-pagination>
          </div>
        </div>
        <hr />
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="
                  exportPDF({
                    route: 'businesses/types/pdf',
                    name_file: 'tipos_empresas.pdf',
                  })
                "
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="
                  exportExcel({
                    route: 'businesses/types/excel',
                    name_file: 'tipos_empresas.xlsx',
                  })
                "
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { MixinExport } from 'src/mixins/mixin-export';
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import { Axios } from 'src/class/Axios.js';
import SweetAlert from 'src/class/Alerts';
import { Popconfirm } from 'element-ui';
import { Pagination as LPagination } from 'src/components/index';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
    [Popconfirm.name]: Popconfirm,
  },
  data() {
    return {
      model: {
        name: null,
        tradename: null,
        nit: null,
        code: null,
        cost_center: null,
        email: null,
        phone: null,
        comercial_activity: null,
        web_site: null,
        icon: 'Logo SmartCultivo.svg',
        about_you: null,
        type_ids: [],
        businesses_ids: [],
      },
      modelValidations: {
        name: {
          required: true,
        },
        nit: {
          required: true,
        },
        phone: {
          required: true,
        },
        email: {
          required: true,
          email: true,
        },
        cost_center: {
          max: 11,
        },
      },
      businesses_list: [],
      businessTypeForm: {
        type: null,
      },
      business_types: [],
      modals: {
        business_types: false,
      },
      fuseSearch: null,
      tableData: [],
      searchQuery: '',
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      renderComponent: true,
    };
  },
  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },

    queriedData() {
      let result = this.tableData;
      if (this.searchQuery !== '') {
        result = this.fuseSearch.search('=' + this.searchQuery + '');
      }
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    total() {
      // this.pagination.total = this.tableData.length;
      return this.pagination.total;
    },
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinForm,
    MixinExport,
    MixinNotification,
  ],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.businesses_list = this.concatAll(this.businesses_list.splice(1));
      this.business_types = this.concatAll(
        this.business_types.splice(1),
        'type'
      );
    },
    addTypesRow() {
      let newRow = { type: '', is_group_businesses: 0 };
      this.tableData = [...this.tableData, newRow];
      setTimeout(() => {
        this.pagination.currentPage = this.$refs.paginationTypes.maxPage;
      }, 150);
    },

    isGroupBusiness() {
      let groups = this.business_types.filter((item) => {
        return (
          item.is_group_businesses && this.model.type_ids.includes(item.id)
        );
      });
      return groups && groups.length > 0 ? true : false;
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);

        let others = [[], []];
        this.business_types.map((item) => {
          if (this.model.type_ids.includes(item.id)) {
            others[0].push(item.type);
          }
        });

        this.businesses_list.filter((item) => {
          if (this.model.businesses_ids.includes(item.id)) {
            others[1].push(item.name);
          }
        });

        this.$emit('fillBusinessForm', 'firstStep', {
          types_names: others[0],
          groups_names: others[1],
        });
        return res;
      });
    },

    searchFuse(keys) {
      this.fuseSearch = new Fuse(this.tableData, {
        useExtendedSearch: true,
        threshold: 0.3,
        keys: keys,
      });
      this.showHideLoading();
    },

    storeUpdateBusinessTypes(index, row) {
      if (row.type != '') {
        this.showHideLoading(true);
        this.businessTypeForm = row;
        this.businessTypeForm.route = 'businesses/types';

        if (row.id) {
          Axios.updateMaster(this.businessTypeForm)
            .then((response) => {
              let indexUpdate = this.business_types.findIndex(
                (tableRow) => tableRow.id === this.businessTypeForm.id
              );
              this.$set(this.tableData, index, response.data.data);
              this.$set(this.business_types, indexUpdate, response.data.data);
              this.showHideLoading();
              this.closeModal('business_types');

              this.showNotification(
                `${response.data.message}`,
                'warning',
                'nc-settings-tool-66',
                i18n.t('show_notification.business.successful_update')
              );

              this.renderComponent = false;
              this.$nextTick(() => {
                this.renderComponent = true;
              });
            })
            .catch((error) => {
              this.closeModal('business_types');
              this.showMessageErrors(error);
            });
        } else {
          Axios.saveMaster(this.businessTypeForm)
            .then((response) => {
              this.business_types.push(response.data.data);
              this.$set(this.tableData, index, response.data.data);
              this.showHideLoading();
              this.closeModal('business_types');

              this.showNotification(
                `${response.data.message}`,
                'success',
                'nc-simple-add',
                i18n.t('common_words.successful_creation')
              );

              this.renderComponent = false;
              this.$nextTick(() => {
                this.renderComponent = true;
              });
            })
            .catch((error) => {
              this.closeModal('business_types');
              this.showMessageErrors(error);
            });
        }
      } else if (row.type == '' || row.type == ' ' || row.type == null) {
        this.showNotification(
          i18n.t('show_notification.company_name_empty'),
          'danger',
          'nc-simple-remove',
          i18n.t('common_words.insert_error')
        );
      }
    },

    deleteBusinessType(index, row) {
      if (row.type != '') {
        SweetAlert.delete(
          i18n.t('common_words.type_of_company') + row.type
        ).then((response) => {
          if (response.value) {
            this.showHideLoading(true);
            this.businessTypeForm = row;
            this.businessTypeForm.route = 'businesses/types';

            Axios.destroyMaster(this.businessTypeForm)
              .then((response) => {
                let indexDelete = this.business_types.findIndex(
                  (tableRow) => tableRow.id === this.businessTypeForm.id
                );

                if (index >= 0) {
                  this.tableData.splice(index, 1);
                }

                if (indexDelete >= 0) {
                  this.business_types.splice(indexDelete, 1);
                }

                this.showHideLoading();

                this.showNotification(
                  `${response.data.message}`,
                  'success',
                  'nc-simple-remove',
                  i18n.t('common_words.successful_deletion')
                );
              })
              .catch((error) => this.showMessageErrors(error));
          }
        });
      } else {
        this.tableData.splice(index, 1);
      }
    },

    exportPDF(data) {
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel(data) {
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('businesses/types/selects'),
      ])
        .then((response) => {
          const [response_businesses, response_types] = response;
          this.businesses_list = this.concatAll(response_businesses.data.data);
          this.business_types = this.concatAll(
            response_types.data.data,
            'type'
          );
          this.tableData = response_types.data.data;
          this.searchFuse(['type']);

          if (sessionStorage.getItem('editForm')) {
            this.businesses_list = this.businesses_list.filter(
              (business) =>
                business.id != JSON.parse(sessionStorage.getItem('editForm')).id
            );
          }

          if (
            !sessionStorage.getItem('editForm') &&
            this.business_types.length == 1
          )
            this.model.type_ids.push(this.business_types[0].id);

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          if (error.response && error.response.data) {
            SweetAlert.warning(error.response.data.message);
          }
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.nit = editForm.nit;
      this.model.code = editForm.code;
      this.model.cost_center = editForm.cost_center;
      this.model.name = editForm.name;
      this.model.tradename = editForm.tradename;
      this.model.email = editForm.email;
      this.model.phone = editForm.phone;
      this.model.comercial_activity = editForm.comercial_activity;
      this.model.web_site = editForm.web_site;
      this.model.icon =
        editForm.icon !== null ? editForm.icon : 'Logo SmartCultivo.svg';
      this.model.about_you = editForm.about_you;
      this.model.type_ids = editForm.type_ids;
      this.model.businesses_ids = editForm.businesses_ids;
    }
  },
};
</script>
<style></style>
